<template>
  <div class="d-flex justify-content-between pb-3 pt-0" 
    style="
      border-bottom: 1px solid #ececef !important;
      margin-left: -20px !important;
      width: calc(100% + 40px) !important;
      padding-bottom: 10px !important;
      margin-top: -10px!important;
    " 
    :key="refresher">
    <div class="mr-auto" style="width: 10% !important">
      <button class="btn btn-outline-muted ml-3 d-inline-block" v-if="_back" @click="back()"><font-awesome-icon icon="long-arrow-alt-left" class="mr-2 fa-sm" />Back</button>        
    </div>
    <div class="text-center my-auto w-auto mx-auto" :key="refresher">
      <span v-for="(item, key) in menu.filter(item => $route.path.includes('/deploy/') ? (item === 'Profile' || item === 'Targeting') : true)" class="mr-1">
        <font-awesome-icon icon="chevron-right" class="mx-1 text-muted fa-sm" v-if="key" /> 
        <span class="fs-12 custom-badge custom-sizing" 
          v-bind:class="{'badge-dark': currentItem === item, 'cursor-pointer': editable }"
          :style="!editable && currentItem !== item ? 'opacity: 0.2;cursor: not-allowed;' : ''"
          @click="clickNavMenu(item)"
        >{{ item.toUpperCase() }}</span>
      </span>
    </div>
    <div style="width: 30% !important" class="ml-auto text-right">
      <span v-show="status" class="mr-3 text-muted badge badge-light fs-13 font-weight-normal" 
      v-bind:class="{
        'badge-success' : status==='Live',
      }"
      style="vertical-align: sub;pointer-events: none;">
        Status: <b class="font-weight-bolder">{{ status }}</b> 
      </span>
      <template v-if="_save && _next">
        <button class="btn btn-outline-muted d-inline-block mr-2" v-if="_save" @click="save()">
          <span>{{ t(saveLabel || 'Save') }}</span>
        </button>
        <button class="btn btn-first d-inline-block mr-3" v-if="_next" @click="next()">
          <span>{{ t(nextLabel || 'Next') }}<font-awesome-icon icon="long-arrow-alt-right" class="ml-2 fa-sm" /></span>
        </button>      
      </template>
      <template v-else-if="_save">
        <button class="btn btn-first d-inline-block mr-2" v-if="_save" @click="save()">
          <span>{{ t(saveLabel || 'Save') }}</span>
        </button>
      </template>
      <template v-else-if="_next">
        <button class="btn btn-first d-inline-block mr-3" v-if="_next" @click="next()">
          <span>{{ t(nextLabel || 'Next') }}</span>
        </button>      
      </template>      
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: ['_back', '_save', '_next', 'navmenu', 'nextLabel', 'saveLabel', 'editable', 'currentItem'],
  data: function () {
    return {
      isLocalhost: false,
      refresher: 0,
      isNew: false,
      isDeploy: false,
      status: '',
      menu: ['Profile', 'Targeting', 'Goal', 'Configuration', 'Summary']
    }
  },
  // watch: {
  //   '$store.getters.testStatus.label': {
  //     handler(newLabel) {
  //       alert(newLabel)

  //       this.status = newLabel;
  //       alert(newLabel)
  //     },
  //     immediate: true
  //   }
  // },  
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.isNew = vm.$route.path.includes('/new')
      vm.isLocalhost = window.location.href.includes('localhost')
      vm.isDeploy = vm.$route.path.includes('/deploy/')
      if(vm.isDeploy) vm.navmenu = vm.navmenu.filter(item => item !== 'Goal');    
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.isNew = this.$route.path.includes('/new')
    this.isLocalhost = window.location.href.includes('localhost')
    this.isDeploy = this.$route.path.includes('/deploy/')
    if(this.isDeploy) this.navmenu = this.navmenu.filter(item => item !== 'Goal');    
    next();
  },  
  mounted() {

    if (this.$store.getters.testStatus.id !== this.$route.params.test_id) {
      this.$http
        .get(process.env.API_ENDPOINT + '/abtest/' + this.$route.params.test_id)
        .then((response) => {
          const result = response.data[0]
          if (result) {

            if (result.status === 1) this.status = 'Live'
            if (result.status === 9) this.status = 'Draft'
            if (result.status === 0) this.status = 'Inactive'
            if (result.is_completed === 1) this.status = 'Completed'

            this.$store.commit('setTestStatus', {
              id:  this.$route.params.test_id,
              label: this.status,
            })

          }
        })      
    } else {
      this.status = this.$store.getters.testStatus.label
    }

    this.isNew = this.$route.path.includes('/new')
    this.isLocalhost = window.location.href.includes('localhost')
    this.isDeploy = this.$route.path.includes('/deploy/')
    if(this.isDeploy) this.navmenu = this.navmenu.filter(item => item !== 'Goal');    
  },
  activated() {
    if(this.isDeploy) this.navmenu = this.navmenu.filter(item => item !== 'Goal');    
  },
  methods: {
    getId(name) {
      return name.match(/\d+/g) ? name.match(/\d+/g).join("") : 0  
    },
    clickNavMenu(item) {
      if (!this.editable) return 
      this.changePath(item)      
    },
    changePath(item) {
      this.$router.push({ path: this.getPath(item) })
    },
    shouldHighlight(item) {
      if (item === 'Targeting') return this.$route.path.includes('/targeting/')
      else if (item === 'Configuration') return this.$route.path.includes('/configuration/')
      else if (item === 'Goal') return this.$route.name.includes('Goal')
      else if (item === 'Summary') return this.$route.path.includes('results')
      else return ['New Experiment', 'Edit Experiment', 'Edit Deploy', 'New Deploy'].includes(this.$route.name)
    },
    getPath(item) {
      let path = this.isDeploy ? 'deploy' : 'experiment'
      let id = this.getId(this.$route.path) || 'ID_NOT_FOUND'

      if (item === 'Profile') return `/${path}/edit/${id}`
      else if (item === 'Targeting') return `/${path}/targeting/${id}`
      else if (item === 'Configuration') return `/${path}/configuration/${id}`
      else if (item === 'Goal') return `/${path}/goal/${id}`
      else if (item === 'Summary') return `/${path}/${id}/results`
      else return `/${path}`
    },
    back(){
      // this.$emit('back')
      this.$router.go(-1)
      // this.goToPrevious()
    },
    save(){
      this.$emit('save', { redirect: null })
    },
    next(){
      this.$emit('next', { redirect: this.getPath(this.nextNavItem()) })
      // You cannot redirect directly from here since you can't guarantee data can be saved
    },
    prevNavItem() {
      let navigationMenu = this.menu.filter(item => this.$route.path.includes('/deploy/') ? (item === 'Profile' || item === 'Targeting') : true)
      const currentIndex = navigationMenu.indexOf(this.currentItem);
      const previousIndex = (currentIndex - 1 + navigationMenu.length) % navigationMenu.length;
      let item = navigationMenu[previousIndex]
      if (currentIndex === 0) item = null
      return item      
    },
    nextNavItem() {
      let navigationMenu = this.menu.filter(item => this.$route.path.includes('/deploy/') ? (item === 'Profile' || item === 'Targeting') : true)
      const currentIndex = navigationMenu.indexOf(this.currentItem);
      const nextIndex = (currentIndex + 1) % navigationMenu.length;
      let item = navigationMenu[nextIndex]
      if (currentIndex === navigationMenu.length - 1) item = null
      return item
    },
    goToNext() {
      this.changePath(this.nextNavItem())
    },
    goToPrevious() {
      this.changePath(this.prevNavItem())
    }   
  },
}
</script>

<style>
.selected-event-item {
  border-radius: 4px;
  background-color: #fff;
  padding: 10px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 3px 0 rgba(0, 0, 0, 0.05);
  border: 1px solid #ced4da;
}

.event-spacing {
  margin: 14px 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/AbNavigation.vue